module.exports = __webpack_public_path__ + "assets/img/role-type-2.62ba5115.png";